// NPM Imports
import React, { Fragment, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Toastr } from "../../../revvComponents";

// Component Imports
import { PriceListCard } from "../../Pricebook/PricebookList";

// Internal Imports
import { IMAGE_URLS } from "../../../constants";

// Action Imports
import { QuotationActions } from "../../../actions";
import { pricebookChangeUpdateDynamicFieldsInDoc } from "../../../actions/DocumentActions";
import LZLoader from "../../../commonComponents/LZLoader";

// Destructuring
const { getPricebooks, togglePriceBookSelectionView, priceBookSelection } =
  QuotationActions;
const { NO_QUOTES } = IMAGE_URLS;

export default function SelectPriceBook(props) {
  // * CALL ACTIONS USING THIS ALIAS
  const dispatch = useDispatch();

  // * MAP DISPATCH TO PROPS SYNTAX IN HOOKS
  const store = useSelector(state => {
    const { dealTableId, documentId, pricelist } = state.QuotationStore;
    const { priceBook: { [dealTableId]: priceBook } = {} } =
      state.DealTableStore;
    return {
      dealTableId,
      documentId,
      priceBook,
      pricelist,
    };
  });

  // * LOCAL STATE DECLARATION SYNTAX
  const [state, setState] = useState({
    loader: false,
  });

  useEffect(() => {
    setState(prev => ({
      ...prev,
      loader: true,
    }));
    function _onInit() {
      dispatch(getPricebooks())
        .then(() => {
          setState(prev => ({
            ...prev,
            loader: false,
          }));
        })
        .catch(err => {
          console.error("SelectPriceBook => useEffect", err);
        });
    }
    _onInit();
  }, [dispatch]);

  function onPriceBookSelection(id) {
    if (store.priceBook && store.priceBook.id === id) {
      dispatch(togglePriceBookSelectionView());
    } else {
      setState(prev => ({
        ...prev,
        loader: true,
      }));
      dispatch(
        priceBookSelection({
          dealTableId: store.dealTableId,
          documentId: store.documentId,
          priceListId: id,
          isPriceBookAttached: props.isPriceBookAttached,
        }),
      )
        .then(response => {
          dispatch(pricebookChangeUpdateDynamicFieldsInDoc(response.currency));
          Toastr.showToastr({
            type: "success",
            message: `You have successfully ${
              props.isPriceBookAttached ? "changed" : "added"
            } the price book`,
            timeout: 3000,
          });
        })
        .catch(err => {
          setState(prev => ({
            ...prev,
            loader: false,
          }));
          Toastr.showToastr({
            type: "failure",
            message: "Oops! Something went wrong. Please try again later.",
            timeout: 3000,
          });
          console.error("SelectPriceBook => onPriceBookSelection", err);
        });
    }
  }

  return (
    <Fragment>
      {state.loader && <LZLoader />}
      {!state.loader && (
        <div className="selectpricebook-wrapper animated fadeinright">
          {store.pricelist.length > 0 && (
            <Fragment>
              <div
                data-test="selectpricebook-header"
                className="selectpricebook-header">
                Select a Price Book to add products from
              </div>
              <div className="selectpricebook-body">
                <div className="selectpricebook-scrollable">
                  {store.pricelist.map(list => (
                    <div
                      data-test="selectpricebook-item"
                      className={`selectpricebook-item ${
                        store.priceBook && store.priceBook.id === list.id
                          ? "is-active"
                          : ""
                      }`}
                      key={list.id}
                      role="button"
                      tabIndex="0"
                      onClick={() => onPriceBookSelection(list.id)}
                      onKeyPress={() => null}>
                      <PriceListCard list={list} showStatus={false} />
                    </div>
                  ))}
                </div>
              </div>
            </Fragment>
          )}
          {store.pricelist.length === 0 && (
            <Fragment>
              <div className="selectpricebook-empty">
                <img
                  src={NO_QUOTES}
                  className="selectpricebook-empty-img"
                  alt="no quotes"
                />
                You have not added a price book yet, please add a price book so
                that you can use it in your quote.
              </div>
            </Fragment>
          )}
        </div>
      )}
    </Fragment>
  );
}
